import React, { useState } from "react";
import "./Faq.css";
import { motion, AnimatePresence } from "framer-motion";
import { FaPlus, FaMinus } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext"; // Import

const Faq = () => {
  const { t } = useLanguage(); // Hooks traduction
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faq">
      <div className="faq-container">
        <div className="faq-header">
          <h2>
            {t.faq.title} <span className="text-gold">{t.faq.titleSpan}</span>
          </h2>
          <div className="section-line"></div>
        </div>

        <div className="faq-grid">
          {/* On map sur les groupes venant du fichier de traduction */}
          {t.faq.groups.map((group, groupIndex) => (
            <div key={groupIndex} className="faq-group">
              <h3 className="faq-category-title">{group.category}</h3>

              <div className="faq-list">
                {group.questions.map((item, i) => {
                  const globalIndex = `${groupIndex}-${i}`;
                  const isOpen = activeIndex === globalIndex;

                  return (
                    <div
                      key={i}
                      className={`faq-item ${isOpen ? "open" : ""}`}
                      onClick={() => toggleQuestion(globalIndex)}
                    >
                      <div className="faq-question">
                        <h4>{item.q}</h4>
                        <span className="faq-icon">
                          {isOpen ? <FaMinus /> : <FaPlus />}
                        </span>
                      </div>
                      <AnimatePresence>
                        {isOpen && (
                          <motion.div
                            className="faq-answer"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                          >
                            <p>{item.a}</p>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
